import CrudActionContainer from './CrudActionContainer';
import ConnectedPageCRUDActions from './ConnectedPageCRUDActions';
import PartnersController from '../controllers/PartnersController';
import commonHandler from '../errorHandlers/common-handler';

class PartnersCRUDActions extends CrudActionContainer {
  setTokenAction: string;
  setTokenPageAction: string;

  constructor() {
    super('PARTNERS');
    this.setTokenAction = super.makeActionKey('SET_TOKEN_ACTION');
    this.setTokenPageAction = super.makeActionKey('SET_TOKEN_PAGE_ACTION');
  }

  createToken(facebookPageId: number) {
    return async dispatch => {
      try {
        dispatch(this.busy(this.createAction));
        const response = await PartnersController.createToken(facebookPageId);
        dispatch(this.setToken(response.token));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  applyToken(companyId: number, token: string) {
    return async dispatch => {
      try {
        dispatch(this.busy(this.updateAction));
        const reponse = await PartnersController.applyToken(companyId, token);
        return reponse.partner.facebookPage;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  revokeToken(
    companyId: number,
    facebookPageId: number,
    paginationPage: number,
    basicCompanyId: number,
  ) {
    return async dispatch => {
      try {
        dispatch(this.busy(this.deleteAction));
        const response = await PartnersController.revokeToken(
          companyId,
          facebookPageId,
        );
        dispatch(
          ConnectedPageCRUDActions.retrieveAllByCompany(
            basicCompanyId,
            paginationPage,
          ),
        );
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  checkToken(token: string) {
    return async dispatch => {
      try {
        dispatch(this.busy(this.retrieveAction));
        const response = await PartnersController.checkToken(token);
        dispatch(this.setTokenPage(response.facebookPage));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  setToken(token: string) {
    return {
      type: this.setTokenAction,
      token,
    };
  }

  setTokenPage(tokenPage: any) {
    return {
      type: this.setTokenPageAction,
      tokenPage,
    };
  }
}

const partnersCRUDActions = new PartnersCRUDActions();

export default partnersCRUDActions;
